// A closed landing-page dialog keeps its iframe mounted. Its document can
// still report "visible", so also inspect the embedding element.
export function workspaceVisible() {
  if (document.visibilityState === 'hidden') return false;
  try {
    if (window.frameElement && !window.frameElement.getClientRects().length) return false;
  } catch {}
  return true;
}

export function observeWorkspaceVisibility(onVisible) {
  let previous = workspaceVisible();
  const inspect = () => {
    const visible = workspaceVisible();
    if (visible === previous) return;
    previous = visible;
    onVisible(visible);
  };
  document.addEventListener('visibilitychange', inspect);
  let observer;
  try {
    if (window.frameElement) {
      observer = new MutationObserver(inspect);
      for (let node = window.frameElement; node; node = node.parentElement) {
        observer.observe(node, { attributes: true, attributeFilter: ['open', 'style', 'class', 'hidden'] });
      }
    }
  } catch {}
  return () => { document.removeEventListener('visibilitychange', inspect); observer?.disconnect(); };
}
